import React, { useEffect } from "react";
import { useAppContext } from "../../../context/AppContext";
import DoorView from "./DoorView";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/pro-solid-svg-icons";
import { cn } from "../../../lib/utils";

import Scene from "./Scene";

const Main = ({hideSidebarBtn}) => {
    const { state, setSidebarOpen, setViewLoading } = useAppContext();


    const { sidebarOpen, viewChangeLoading } = state;

    useEffect(() => {
        const timer = setTimeout(() => {
            setViewLoading(false);
        }, 1200);

        return () => clearTimeout(timer);
    }, [setViewLoading]);

    return (
        <div className="relative flex-none h-[32vh] sm:flex-1 sm:h-[65vh] lg:h-[80vh] xl:h-full">
            <DoorView/>
            <div className="w-full h-full relative">
                {viewChangeLoading ? (
                    <div
                        className="h-full w-full flex items-center justify-center"
                        role="status"
                    >
                        <div className="view-loading">
                            <div className="loading">
                                <div className="obj"></div>
                                <div className="obj"></div>
                                <div className="obj"></div>
                                <div className="obj"></div>
                                <div className="obj"></div>
                                <div className="obj"></div>
                                <div className="obj"></div>
                                <div className="obj"></div>
                            </div>
                        </div>
                        <span className="sr-only">Loading...</span>
                    </div>
                ) : (
                    <>
                        <Scene/>
                    </>
                )}
            </div>
            {!hideSidebarBtn && (
                <div
                    className="absolute top-1/2 right-0 size-44 bg-[#555454] text-white -translate-y-1/2 cursor-pointer lg:flex items-center justify-center hidden"
                    onClick={() => setSidebarOpen()}
                    style={{
                        clipPath: "polygon(90% 10%, 100% 0, 100% 100%, 90% 90%)",
                    }}
                >
                    <FontAwesomeIcon
                        className={cn(
                            "absolute top-1/2 right-1 -translate-y-1/2  text-white transition-all",
                            {
                                ["rotate-180"]: sidebarOpen,
                            }
                        )}
                        icon={faCaretRight}
                    />
                </div>
            )}


        </div>
    );
};

export default Main;
